import * as React from "react";

const VisitorInvitationIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#000"
      d="M10.5 17.25a.75.75 0 1 0 0-1.5H3a.75.75 0 0 1-.75-.75V5.805l7.114 4.151a2.27 2.27 0 0 0 2.267 0l7.119-4.153V9a.75.75 0 1 0 1.5 0V4.5A2.25 2.25 0 0 0 18 2.25H3a2.25 2.25 0 0 0-1.837.962A2.3 2.3 0 0 0 .75 4.5V15A2.25 2.25 0 0 0 3 17.25zM3 3.75h15a.74.74 0 0 1 .639.381l-7.764 4.53a.76.76 0 0 1-.755 0L2.36 4.134A.74.74 0 0 1 3 3.75"
    ></path>
    <g clipPath="url(#clip0_193_1830)">
      <path
        fill="#000"
        d="M13 12.625a2.626 2.626 0 0 1 4.686-1.627 2.624 2.624 0 0 1-.263 3.539A4.13 4.13 0 0 1 19.7 17.6a.563.563 0 1 1-1.112.176 3 3 0 0 0-5.925 0 .564.564 0 0 1-1.111-.177 4.13 4.13 0 0 1 2.275-3.062A2.63 2.63 0 0 1 13 12.625m6.75-1.125a2.251 2.251 0 0 1 1.665 3.764 3.75 3.75 0 0 1 1.92 2.259.56.56 0 0 1-.664.715.56.56 0 0 1-.412-.386 2.63 2.63 0 0 0-1.891-1.779.56.56 0 0 1-.43-.547v-.264a.56.56 0 0 1 .311-.504 1.126 1.126 0 0 0-.5-2.133.563.563 0 0 1 0-1.125m-4.125-.375a1.498 1.498 0 0 0-1.417 2.081 1.5 1.5 0 1 0 1.417-2.081"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_193_1830">
        <path fill="#fff" d="M11.5 8.5h12v12h-12z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default VisitorInvitationIcon;
